import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import NameFields from "@/components/NameFields";

export default function RegisterScout() {
    const navigate = useNavigate();
    const { registerScout } = useAuth();
    const [form, setForm] = useState({ first_name: "", middle_initial: "", last_name: "", organization: "", email: "", password: "", home_zip: "" });
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        const mi = form.middle_initial ? `${form.middle_initial}. ` : "";
        const name = `${form.first_name.trim()} ${mi}${form.last_name.trim()}`.trim();
        if (!form.first_name.trim() || !form.last_name.trim()) { setError("First and last name are required"); return; }
        setSubmitting(true);
        const { first_name, middle_initial, last_name, ...rest } = form;
        const res = await registerScout({ ...rest, name });
        setSubmitting(false);
        if (res.ok) navigate("/");
        else setError(res.error);
    };

    return (
        <div className="max-w-md mx-auto px-6 py-12">
            <div className="text-[#ff4500] text-xs uppercase tracking-[0.3em] mb-2">Scout signup</div>
            <h1 className="font-display text-5xl tracking-wide">Evaluator access</h1>
            <p className="text-sm text-[#a0a0a0] mt-2">
                Independent scouts: create an account to browse verified players.{" "}
                <Link to="/register" className="text-[#ff4500] hover:underline">Wrong type?</Link>
            </p>

            <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="register-scout-form">
                <NameFields testidPrefix="scout" section="scout" first={form.first_name} mi={form.middle_initial} last={form.last_name} onChange={(patch) => setForm((f) => ({ ...f, ...patch }))} />
                <F label="Organization (optional)" testid="scout-org" value={form.organization} onChange={set("organization")} />
                <F label="Email" type="email" testid="scout-email" value={form.email} onChange={set("email")} required autoComplete="email" />
                <p className="text-[10px] text-[#ff4500] -mt-2">Your email can't be changed later.</p>
                <F label="Password (min 6 chars)" type="password" testid="scout-password" value={form.password} onChange={set("password")} required minLength={6} />
                <F label="Home ZIP (used to compute distances)" testid="scout-zip" value={form.home_zip} onChange={set("home_zip")} required pattern="[0-9]{5}" />

                {error && <div data-testid="scout-error" className="text-sm text-[#ff4500] border border-[#ff4500] p-3">{error}</div>}

                <Button type="submit" disabled={submitting} data-testid="scout-submit" className="w-full h-12 rounded-none bg-[#ff4500] hover:bg-[#ff5722] uppercase tracking-[0.2em] text-xs font-semibold">
                    {submitting ? "Creating…" : "Create Scout Account"}
                </Button>

                <p className="text-xs text-[#a0a0a0] pt-2">
                    Note: to protect minors' data, scout accounts require admin verification before browsing players.
                </p>
            </form>
        </div>
    );
}

function F({ label, testid, ...props }) {
    return (
        <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-[#a0a0a0]">{label}</Label>
            <Input data-testid={testid} {...props} className="mt-2 h-12 rounded-none bg-[#141414] border-[#2a2a2a]" />
        </div>
    );
}
